import styled from '@emotion/styled';
import { QcsPaper } from '../../common/basic/QcsPaper';

type Tone = 'neutral' | 'positive' | 'muted';

const toneColor = (theme: any, tone: Tone): string => {
  switch (tone) {
    case 'positive':
      return theme.palette.success?.main ?? '#16a34a';
    case 'muted':
      return theme.palette.text.secondary;
    case 'neutral':
    default:
      return theme.palette.text.primary;
  }
};

export const KpiRoot = styled(QcsPaper)({
  padding: '1.25rem 1.5rem',
  borderRadius: '12px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: '0.75rem',
  minHeight: 0,
});

export const KpiLabelRow = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '0.35rem',
});

export const KpiLabel = styled.div(({ theme }) => ({
  fontSize: '0.7rem',
  color: theme.palette.text.secondary,
  fontWeight: 500,
  textTransform: 'uppercase' as const,
  letterSpacing: '0.04em',
  lineHeight: 1.25,
}));

export const KpiInfoIcon = styled.span(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  color: theme.palette.text.disabled,
  cursor: 'help',
  '& svg': {
    fontSize: '0.9rem',
  },
}));

export const KpiValue = styled.div<{ tone: Tone }>(({ theme, tone }) => ({
  fontSize: '1.05rem',
  fontWeight: 400,
  lineHeight: 1.2,
  color: toneColor(theme, tone),
  letterSpacing: '-0.01em',
  fontVariantNumeric: 'tabular-nums',
}));

/* ---- Duration composite tile ---- */

export const DurationRoot = styled(QcsPaper)({
  padding: '1.25rem 1.5rem',
  borderRadius: '12px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: '0.75rem',
  minHeight: 0,
});

export const DurationHeader = styled.div(({ theme }) => ({
  fontSize: '0.7rem',
  color: theme.palette.text.secondary,
  fontWeight: 500,
  textTransform: 'uppercase' as const,
  letterSpacing: '0.04em',
  lineHeight: 1.25,
}));

export const DurationPair = styled.div({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '1.25rem',
});

export const DurationCell = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: '0.2rem',
});

export const DurationCellLabel = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.3rem',
  fontSize: '0.7rem',
  color: theme.palette.text.secondary,
  fontWeight: 400,
}));

export const DurationCellValue = styled.div(({ theme }) => ({
  fontSize: '1rem',
  fontWeight: 400,
  lineHeight: 1.2,
  color: theme.palette.text.primary,
  fontVariantNumeric: 'tabular-nums',
  letterSpacing: '-0.01em',
}));
